import { MutationTuple, useMutation } from '@apollo/client';

import {
  useCurrentCompanyId,
  MERGE_ASC_PROJECTS,
  GET_ASC_PROJECTS,
  MergeAscProjectsMutation,
  MergeAscProjectsMutationVariables,
  GetAscProjectsQueryVariables,
} from '@neo.tax/shared';

import { useAscContext } from '../context';

export const useMergeAscProjectsMutation = (): MutationTuple<
  MergeAscProjectsMutation,
  MergeAscProjectsMutationVariables
> => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId, periodName } = useAscContext();
  const mutation = useMutation<MergeAscProjectsMutation, MergeAscProjectsMutationVariables>(MERGE_ASC_PROJECTS, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: GET_ASC_PROJECTS,
        variables: { companyId, fiscalYearId, periodName } satisfies GetAscProjectsQueryVariables,
      },
    ],
  });

  return mutation;
};
